import { useState } from "react";

import { ArrowUpShort } from "react-bootstrap-icons";

import "./ScrollButton.css";


export default function ScrollButton() {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 10) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  window.addEventListener("scroll", toggleVisible);
  return (
    <div className="go-top__container">
      <button className={`square-button--darker floating-btn ${visible && "visible"}`} onClick={scrollToTop} id="qwerty"><ArrowUpShort size="1.5rem" /></button>
    </div>
  );
}
